module.exports = __webpack_public_path__ + "media/images/sp/stores/fuji/fuji_sns_04-7fc34d169484d1961c3f5a32394b301d.jpg";